import { apiCall, apiCallAdmin } from "../../../services/api-service.js";





export const getfielsApi = async (value) => {
  const response = await apiCall("GET", `register_page${value}`);
  return response.data;
};


export const registerSubmitApi = async (data) => {
    const response = await apiCall("POST", `register_page`, data);
    return response.data;
};

export const getGateListApi = async (term) => {
  return await apiCall("GET", `gate/autosuggestion?term=${term}`);
};

export const getDeptListApi = async (term) => {
  return await apiCallAdmin("GET", `get_department?term=${term}`);
};

export const getFieldListApi = async (term) => {
  return await apiCall("GET", `register_page/get_pages`);
};


export const getOptionsListApi = async (term) => {
  return await apiCall("GET", `register_page/get_fields/${term}`);
};

//Edit
export const getEditApi = async (id) => { 
  const response = await apiCall("GET", `register_page/get/${id}`);
  return response.data;
};

//Update
export const UpdateFieldsApi = async (data,id) => {  
  return await apiCall("PUT", `register_page/${id}`, data);
};